import {AdcValue} from '@models/adminstration/gateway/gateway-configuration/adc-value';

export class AdcSetting {
  sampleRateMs: number = 0;
  values: AdcValue[] = [];
}